import { Model } from '@/clients/http'

import { ProfileHttpParams } from '@/types/http-params/ProfileHttpParams'
import { ProfileResponses } from '@/types/http-responses/ProfileResponses'

export class ProfileModel extends Model {
  public static readonly correlations = {
    GET: 'GET_PROFILE',
    UPDATE: 'UPDATE_PROFILE',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  }

  public static readonly endpoints = {
    get: (props?: ProfileHttpParams.Get) =>
      this.createEndpoint({
        url: '/api/backoffice/profile',
        query: props?.query,
      }),

    update: (props?: ProfileHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/profile',
      }),

    changePassword: () =>
      this.createEndpoint({
        url: '/api/backoffice/profile/password',
      }),
  }

  public static readonly get = async (props?: ProfileHttpParams.Get) => {
    return this.createHttpRequest<ProfileResponses.Get, ProfileResponses.GetError>({
      correlationKey: this.correlations.GET,
      payload: {
        method: 'get',
        url: this.endpoints.get(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly update = async (props: ProfileHttpParams.Update) => {
    return this.createHttpRequest<ProfileResponses.Update, ProfileResponses.UpdateError>({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly changePassword = async (props: ProfileHttpParams.ChangePassword) => {
    return this.createHttpRequest<
      ProfileResponses.ChangePassword,
      ProfileResponses.ChangePasswordError
    >({
      correlationKey: this.correlations.CHANGE_PASSWORD,
      payload: {
        method: 'put',
        url: this.endpoints.changePassword(),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
